<template>
  <interact draggable :dragOption="dragOption" class="resize-drag notes-shell" :style="style" @dragmove="dragmove" :class="{ fullscreen: $store.getters.isFullscreenStickies }">
    <div ref="container" class="notes-window" :class="{ fullscreen: $store.getters.isFullscreenStickies }">
      <header class="notes-toolbar app-toolbar" @dblclick.self="$store.commit('toggleFullscreenStickies')">
        <div class="notes-controls">
          <button type="button" class="traffic red" aria-label="Close Notes" @click="closeStickies"></button>
          <button type="button" class="traffic yellow" aria-label="Minimize Notes" @click="closeStickies"></button>
          <button type="button" class="traffic green" aria-label="Toggle fullscreen" @click="$store.commit('toggleFullscreenStickies')"></button>
        </div><strong>Notes</strong>
      </header>
      <div class="notes-content"><p>Your personal scratchpad</p><textarea aria-label="Your note" v-model="notepadDataLocally" @input="onChangeTextarea" placeholder="A few ideas…" spellcheck="true"></textarea></div>
    <div v-for="edge in ['b', 'l', 't', 'r']" :key="edge" class="window-resizer" :class="'window-resizer-' + edge" @mousedown.prevent="startResize($event, edge)"></div>
    </div>
  </interact>
</template>
<style scoped>
.notes-shell { width:620px; height:420px; min-width:360px; color-scheme:light; }
.notes-window { box-sizing:border-box; display:flex; flex-direction:column; width:100%; max-width:90vw; height:100%; max-height:calc(var(--vh,1vh) * 100 - 130px); min-height:240px; background:#fff3a5; color:#292719; border:1px solid #bba54c88; border-radius:12px; overflow:hidden; box-shadow:0 16px 40px #0003; }
.notes-toolbar { display:grid; grid-template-columns:1fr auto 1fr; align-items:center; padding:0 16px; background:#f8df68; border-bottom:1px solid #c9ae4f77; cursor:grab; }
.notes-toolbar strong { font-size:15px; font-weight:600; }.notes-controls { display:flex; align-items:center; gap:8px; }.traffic { padding:0; width:12px; height:12px; border:0; border-radius:50%; cursor:pointer; }.red { background:#ff5f57; }.yellow { background:#febc2e; }.green { background:#28c840; }button:focus-visible { outline:2px solid #685918; outline-offset:3px; }
.notes-content { flex:1; min-height:0; display:flex; flex-direction:column; padding:24px; }.notes-content p { margin:0 0 24px; font-size:13px; color:#625a32; }
textarea { box-sizing:border-box; flex:1; width:100%; min-height:0; padding:0; border:0; background:transparent; color:#292719; caret-color:#292719; font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif; font-size:18px; line-height:1.7; resize:none; outline:none; box-shadow:none; overflow:auto; }textarea::placeholder { color:#625a32; opacity:1; }
.window-resizer { position:absolute; z-index:12; }.window-resizer-r { right:0; top:46px; bottom:0; width:7px; cursor:ew-resize; }.window-resizer-l { left:0; top:46px; bottom:0; width:7px; cursor:ew-resize; }.window-resizer-b { bottom:0; left:0; right:0; height:7px; cursor:ns-resize; }.window-resizer-t { top:0; left:100px; right:20px; height:6px; cursor:ns-resize; }
.fullscreen { width:100% !important; max-width:100%; height:var(--fullscreen) !important; max-height:var(--fullscreen); }
@media(max-width:600px) { .window-resizer { display:none; } .notes-window { width:90vw; height:calc(var(--vh,1vh) * 100 - 130px); }.notes-content { padding:22px 20px; }textarea { font-size:17px; }.notes-toolbar { padding:0 14px; } }
</style>
<script>
import interact from "interactjs";
export default {
  props: {
    // shownProp: Boolean
  },
  data: function () {
    return {
      notepadDataLocally: this.$store.getters.notepadData,
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0,
      },
      resizeOption: {
        edges: { left: true, right: true, bottom: true, top: true },
      },
      dragOption: {
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: "parent",
            endOnly: true,
          }),
        ],
        // ignoreFrom: 'textarea',
        allowFrom: ".notes-toolbar",
        ignoreFrom: "button",
      },
      // values for interact.js transformation
      x: 0,
      y: 0,
      w: null,
      h: null,
      resizeCleanup: null,
    };
  },
  computed: {
    style() {
      return {
        height: `${this.h}px`,
        width: `${this.w}px`,
        transform: `translate(${this.x}px, ${this.y}px)`,
        "--fullscreen": window.innerHeight - 30 + "px",
      };
    },
  },
  methods: {
    startResize(event, edge) {
      if (this.$store.getters.isFullscreenStickies || window.matchMedia("(max-width: 600px)").matches) return;
      if (this.resizeCleanup) this.resizeCleanup();
      const initial = this.$refs.container.getBoundingClientRect();
      const startX = event.clientX, startY = event.clientY, initialX = this.x, initialY = this.y;
      const move = next => {
        const dx = next.clientX - startX, dy = next.clientY - startY;
        if (edge === "r" || edge === "l") { const width = Math.max(360, Math.min(window.innerWidth * .95, initial.width + (edge === "r" ? dx : -dx))); this.w = width; this.x = edge === "r" ? initialX + (width - initial.width) : initialX; }
        if (edge === "b" || edge === "t") { const height = Math.max(240, Math.min(window.innerHeight - 50, initial.height + (edge === "b" ? dy : -dy))); this.h = height; this.y = edge === "t" ? initialY + (initial.height - height) : initialY; }
      };
      this.resizeCleanup = () => { document.removeEventListener("mousemove", move); document.removeEventListener("mouseup", this.resizeCleanup); this.resizeCleanup = null; };
      document.addEventListener("mousemove", move); document.addEventListener("mouseup", this.resizeCleanup);
    },
    onChangeTextarea() {
      this.$store.commit("updateNotepad", this.notepadDataLocally);
    },
    dragmove(event) {
      this.x += event.dx;
      this.y += event.dy;
      this.$store.commit("zIndexIncrement", "stickies");
    },
    resizemove(event) {
      this.w = event.rect.width;
      this.h = event.rect.height;

      this.x += event.deltaRect.left;
      this.y += event.deltaRect.top;
    },
    dragMouseDown: function (event) {
      event.preventDefault();
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },
    elementDrag: function (event) {
      event.preventDefault();
      this.positions.movementX = this.positions.clientX - event.clientX;
      this.positions.movementY = this.positions.clientY - event.clientY;
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      // set the element's new position:
      this.$refs.draggableContainer.style.top =
        this.$refs.draggableContainer.offsetTop -
        this.positions.movementY +
        "px";
      this.$refs.draggableContainer.style.left =
        this.$refs.draggableContainer.offsetLeft -
        this.positions.movementX +
        "px";
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
    onClickLog() {
      alert("Hello! I am an alert box!!");
    },
    closeStickies(e) {
      e.stopPropagation();
      this.$store.commit("toggleShownStickies", false);
      this.$store.commit("changeActiveWindow", "Finder");
    },
  },
  mounted: function () {
    // Query the element
    const ele = this.$refs.container;

    // The current position of mouse
    let x = 0;
    let y = 0;

    // The dimension of the element
    let w = 0;
    let h = 0;

    const mouseDownHandlerRight = function (e) {
      x = e.clientX;

      const styles = window.getComputedStyle(ele);
      w = parseInt(styles.width, 10);

      document.addEventListener("mousemove", mouseMoveHandlerRight);
      document.addEventListener("mouseup", mouseUpHandlerRight);
    };

    const mouseDownHandlerLeft = function (e) {
      x = e.clientX;

      const styles = window.getComputedStyle(ele);
      w = parseInt(styles.width, 10);

      document.addEventListener("mousemove", mouseMoveHandlerLeft);
      document.addEventListener("mouseup", mouseUpHandlerLeft);
    };

    const mouseDownHandlerUp = function (e) {
      y = e.clientY;

      const styles = window.getComputedStyle(ele);
      h = parseInt(styles.height, 10);

      document.addEventListener("mousemove", mouseMoveHandlerUp);
      document.addEventListener("mouseup", mouseUpHandlerUp);
    };

    const mouseDownHandlerDown = function (e) {
      y = e.clientY;

      const styles = window.getComputedStyle(ele);
      h = parseInt(styles.height, 10);

      document.addEventListener("mousemove", mouseMoveHandlerDown);
      document.addEventListener("mouseup", mouseUpHandlerDown);
    };

    const mouseMoveHandlerUp = function (e) {
      // How far the mouse has been moved
      const dy = e.clientY - y;

      // Adjust the dimension of element
      ele.style.height = `${h - dy}px`;
    };

    const mouseMoveHandlerDown = function (e) {
      // How far the mouse has been moved
      const dy = e.clientY - y;

      // Adjust the dimension of element
      ele.style.height = `${h + dy}px`;
    };

    const mouseMoveHandlerRight = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - x;

      // Adjust the dimension of element
      ele.style.width = `${w + dx}px`;
    };

    const mouseMoveHandlerLeft = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - x;

      // Adjust the dimension of element
      ele.style.width = `${w - dx}px`;
    };

    const mouseUpHandlerUp = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerUp);
      document.removeEventListener("mouseup", mouseUpHandlerUp);
    };

    const mouseUpHandlerDown = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerDown);
      document.removeEventListener("mouseup", mouseUpHandlerDown);
    };

    const mouseUpHandlerRight = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerRight);
      document.removeEventListener("mouseup", mouseUpHandlerRight);
    };

    const mouseUpHandlerLeft = function () {
      // Remove the handlers of `mousemove` and `mouseup`
      document.removeEventListener("mousemove", mouseMoveHandlerLeft);
      document.removeEventListener("mouseup", mouseUpHandlerLeft);
    };
    // Query all resizers
    const resizersRight = ele.querySelectorAll(".resizer-r");
    const resizersUp = ele.querySelectorAll(".resizer-t");
    const resizersDown = ele.querySelectorAll(".resizer-b");
    const resizersLeft = ele.querySelectorAll(".resizer-l");

    [].forEach.call(resizersRight, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerRight);
    });

    [].forEach.call(resizersUp, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerUp);
    });

    [].forEach.call(resizersDown, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerDown);
    });

    [].forEach.call(resizersLeft, function (resizer) {
      resizer.addEventListener("mousedown", mouseDownHandlerLeft);
    });
  },
  beforeDestroy() { if (this.resizeCleanup) this.resizeCleanup(); },
};
</script>
